import React, { Component } from 'react';
import ps from './Auth.module.css';
import Button from '../../components/UI/Button/Button';
import Input from '../../components/UI/Input/Input';
import is from 'is_js';
import { connect } from 'react-redux';
import { auth } from './../../store/actions/auth';
import { Link } from 'react-router-dom';
import { Particles } from 'react-particles-js';

class Auth extends Component {
  state = {
    isFormValid: false,
    formControls: {
      email: {
        value: '',
        type: 'email',
        placeholder: 'Email',
        autoComplete: 'on',
        // label: 'Email',
        errorMessage: 'Введите корректный email!',
        valid: false,
        touched: false,
        validation: {
          required: true,
          email: true,
        },
      },
      password: {
        value: '',
        type: 'password',
        placeholder: 'Passsword',
        autoComplete: 'off',

        // label: 'Пароль',
        errorMessage: 'Введите пароль не менее 6 символов!',
        valid: false,
        touched: false,
        validation: {
          required: true,
          minLength: 6,
        },
      },
    },
  };

  loginHandler = () => {
    this.props.auth(
      this.state.formControls.email.value,
      this.state.formControls.password.value,
      true
    );
  };

  submitHandler = (event) => {
    event.preventDefault();
  };

  validateControl(value, validation) {
    if (!validation) {
      return true;
    }

    let isValid = true;

    if (validation.required) {
      isValid = value.trim() !== '' && isValid;
    }

    if (validation.email) {
      isValid = is.email(value) && isValid;
    }

    if (validation.minLength) {
      isValid = value.length >= validation.minLength && isValid;
    }

    return isValid;
  }
  onChangeHandler = (event, controlName) => {
    const formControls = { ...this.state.formControls };
    const control = { ...formControls[controlName] };

    control.value = event.target.value;
    control.touched = true;
    control.valid = this.validateControl(control.value, control.validation);

    formControls[controlName] = control;

    let isFormValid = true;

    Object.keys(formControls).forEach((name) => {
      isFormValid = formControls[name].valid && isFormValid;
    });

    this.setState({
      formControls,
      isFormValid,
    });
  };

  renderInputs() {
    return Object.keys(this.state.formControls).map((controlName, index) => {
      const control = this.state.formControls[controlName];
      return (
        <Input
          key={controlName + index}
          placeholder={control.placeholder}
          autoComplete={control.autoComplete}
          type={control.type}
          value={control.value}
          valid={control.valid}
          touched={control.touched}
          label={control.label}
          shouldValidate={!!control.validation}
          errorMessage={control.errorMessage}
          onChange={(event) => this.onChangeHandler(event, controlName)}
        />
      );
    });
  }

  render() {
    return (
      <div>
        <div className={ps.particles_js}>
          <div className="animate__animated animate__zoomIn">
            <div className={ps.container}>
              <form
                onSubmit={this.submitHandler}
                name="form1"
                className={ps.box}
              >
                <h2>
                  CVAD<span>Online</span>
                </h2>
                <h5 align="left">
                  Автоматизированная система центров временной адаптации
                </h5>
                {this.renderInputs()}
                <Link to="/zan" className={ps.forgetpass}>
                  По настоящему Соглашению пользователь несет ответственность за
                  несанкционированный доступ к данным относящимся к защищаемой
                  законом врачебной тайне
                </Link>

                <Button
                  type="SignIn"
                  onClick={this.loginHandler}
                  disabled={!this.state.isFormValid}
                >
                  Войти
                </Button>
              </form>
            </div>
            <div className={ps.footer}>
              <span>
                Made with <i className="fa fa-heart " />
                <a href="https://www.instagram.com/muxamedjanov.x/">
                  &nbsp;&nbsp;By Hasan Mukhamedjanov
                </a>
              </span>
            </div>
          </div>
          <Particles
            params={
              ('particles-js',
              {
                particles: {
                  number: {
                    value: 60,
                    density: {
                      enable: true,
                      value_area: 800,
                    },
                  },
                  color: {
                    value: '#ffffff',
                  },
                  shape: {
                    type: 'circle',
                    stroke: {
                      width: 0,
                      color: '#000000',
                    },
                    polygon: {
                      nb_sides: 5,
                    },
                  },
                  opacity: {
                    value: 0.1,
                    random: false,
                    anim: {
                      enable: false,
                      speed: 1,
                      opacity_min: 0.1,
                      sync: false,
                    },
                  },
                  size: {
                    value: 6,
                    random: false,
                    anim: {
                      enable: false,
                      speed: 40,
                      size_min: 0.1,
                      sync: false,
                    },
                  },
                  line_linked: {
                    enable: true,
                    distance: 150,
                    color: '#ffffff',
                    opacity: 0.1,
                    width: 2,
                  },
                  move: {
                    enable: true,
                    speed: 1.5,
                    direction: 'top',
                    random: false,
                    straight: false,
                    out_mode: 'out',
                    bounce: false,
                    attract: {
                      enable: false,
                      rotateX: 600,
                      rotateY: 1200,
                    },
                  },
                },
                interactivity: {
                  detect_on: 'canvas',
                  events: {
                    onhover: {
                      enable: false,
                      mode: 'repulse',
                    },
                    onclick: {
                      enable: false,
                      mode: 'push',
                    },
                    resize: true,
                  },
                  modes: {
                    grab: {
                      distance: 400,
                      line_linked: {
                        opacity: 1,
                      },
                    },
                    bubble: {
                      distance: 400,
                      size: 40,
                      duration: 2,
                      opacity: 8,
                      speed: 3,
                    },
                    repulse: {
                      distance: 200,
                      duration: 0.4,
                    },
                    push: {
                      particles_nb: 4,
                    },
                    remove: {
                      particles_nb: 2,
                    },
                  },
                },
                retina_detect: true,
              })
            }
          />
        </div>
      </div>
    );
  }
}

function mapDispathToProps(dispatc) {
  return {
    auth: (email, password, isLogin) => dispatc(auth(email, password, isLogin)),
  };
}

export default connect(null, mapDispathToProps)(Auth);
